/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ImageShapeEnum = "circle" | "container" | "shipment" | "square" | "vessel" | "voyage" | "%future added value";
export type FeedImages_data = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly url: string | null;
            readonly shape: ImageShapeEnum | null;
            readonly overlay: string | null;
        } | null;
    } | null> | null;
    readonly " $refType": "FeedImages_data";
};
export type FeedImages_data$data = FeedImages_data;
export type FeedImages_data$key = {
    readonly " $data"?: FeedImages_data$data;
    readonly " $fragmentRefs": FragmentRefs<"FeedImages_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedImages_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shape",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "overlay",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ImageConnection",
  "abstractKey": null
};
(node as any).hash = '00a639b26414c867f8ea08e3fea7111c';
export default node;
